import { default as _403zu2UJEumH2Meta } from "/app/pages/403.vue?macro=true";
import { default as _409qALGmnAWekMeta } from "/app/pages/409.vue?macro=true";
import { default as account_45pendingjoGMgpRrmvMeta } from "/app/pages/account-pending.vue?macro=true";
import { default as indexGN7V2AUcgTMeta } from "/app/pages/carrier-profile/index.vue?macro=true";
import { default as manage_45fleetgCbLW8JTA4Meta } from "/app/pages/carrier-profile/manage-fleet.vue?macro=true";
import { default as manage_45usersh1a5lFIN0qMeta } from "/app/pages/carrier-profile/manage-users.vue?macro=true";
import { default as your_45profileDYqxbB6159Meta } from "/app/pages/carrier-profile/your-profile.vue?macro=true";
import { default as check_45emailiHjmbqs5OtMeta } from "/app/pages/check-email.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as legaljKqPCMARDuMeta } from "/app/pages/legal.vue?macro=true";
import { default as logoutHaVXWqg8UAMeta } from "/app/pages/logout.vue?macro=true";
import { default as Active4iRAkJAMm0Meta } from "/app/pages/manage-jobs/Active.vue?macro=true";
import { default as Deliveredvfb81uAI22Meta } from "/app/pages/manage-jobs/Delivered.vue?macro=true";
import { default as DispatchedMxmAZ9Ki5WMeta } from "/app/pages/manage-jobs/Dispatched.vue?macro=true";
import { default as _91editIdSlug_93ZqADKPdyXXMeta } from "/app/pages/manage-jobs/edit/[editIdSlug].vue?macro=true";
import { default as indexzZB4qxhBUUMeta } from "/app/pages/manage-jobs/index.vue?macro=true";
import { default as PendingPYWl6WJF6DMeta } from "/app/pages/manage-jobs/Pending.vue?macro=true";
import { default as PickedupsHtnhdnzTfMeta } from "/app/pages/manage-jobs/Pickedup.vue?macro=true";
import { default as no_45connectionZEl2wWUUlEMeta } from "/app/pages/no-connection.vue?macro=true";
import { default as recommendedVRaUeqH5vCMeta } from "/app/pages/recommended.vue?macro=true";
import { default as signupezBbZGXKU6Meta } from "/app/pages/signup.vue?macro=true";
import { default as something_45went_45wrong1q7sKZbEZPMeta } from "/app/pages/something-went-wrong.vue?macro=true";
import { default as staged4ZpHHAhzcXMeta } from "/app/pages/staged.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/app/pages/403.vue")
  },
  {
    name: "409",
    path: "/409",
    component: () => import("/app/pages/409.vue")
  },
  {
    name: "account-pending",
    path: "/account-pending",
    component: () => import("/app/pages/account-pending.vue")
  },
  {
    name: "carrier-profile",
    path: "/carrier-profile",
    meta: indexGN7V2AUcgTMeta || {},
    component: () => import("/app/pages/carrier-profile/index.vue")
  },
  {
    name: "carrier-profile-manage-fleet",
    path: "/carrier-profile/manage-fleet",
    meta: manage_45fleetgCbLW8JTA4Meta || {},
    component: () => import("/app/pages/carrier-profile/manage-fleet.vue")
  },
  {
    name: "carrier-profile-manage-users",
    path: "/carrier-profile/manage-users",
    meta: manage_45usersh1a5lFIN0qMeta || {},
    component: () => import("/app/pages/carrier-profile/manage-users.vue")
  },
  {
    name: "carrier-profile-your-profile",
    path: "/carrier-profile/your-profile",
    meta: your_45profileDYqxbB6159Meta || {},
    component: () => import("/app/pages/carrier-profile/your-profile.vue")
  },
  {
    name: "check-email",
    path: "/check-email",
    meta: check_45emailiHjmbqs5OtMeta || {},
    component: () => import("/app/pages/check-email.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    component: () => import("/app/pages/legal.vue")
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "manage-jobs-Active",
    path: "/manage-jobs/Active",
    meta: Active4iRAkJAMm0Meta || {},
    component: () => import("/app/pages/manage-jobs/Active.vue")
  },
  {
    name: "manage-jobs-Delivered",
    path: "/manage-jobs/Delivered",
    meta: Deliveredvfb81uAI22Meta || {},
    component: () => import("/app/pages/manage-jobs/Delivered.vue")
  },
  {
    name: "manage-jobs-Dispatched",
    path: "/manage-jobs/Dispatched",
    meta: DispatchedMxmAZ9Ki5WMeta || {},
    component: () => import("/app/pages/manage-jobs/Dispatched.vue")
  },
  {
    name: "manage-jobs-edit-editIdSlug",
    path: "/manage-jobs/edit/:editIdSlug()",
    meta: _91editIdSlug_93ZqADKPdyXXMeta || {},
    component: () => import("/app/pages/manage-jobs/edit/[editIdSlug].vue")
  },
  {
    name: "manage-jobs",
    path: "/manage-jobs",
    meta: indexzZB4qxhBUUMeta || {},
    component: () => import("/app/pages/manage-jobs/index.vue")
  },
  {
    name: "manage-jobs-Pending",
    path: "/manage-jobs/Pending",
    meta: PendingPYWl6WJF6DMeta || {},
    component: () => import("/app/pages/manage-jobs/Pending.vue")
  },
  {
    name: "manage-jobs-Pickedup",
    path: "/manage-jobs/Pickedup",
    meta: PickedupsHtnhdnzTfMeta || {},
    component: () => import("/app/pages/manage-jobs/Pickedup.vue")
  },
  {
    name: "no-connection",
    path: "/no-connection",
    component: () => import("/app/pages/no-connection.vue")
  },
  {
    name: "recommended",
    path: "/recommended",
    meta: recommendedVRaUeqH5vCMeta || {},
    component: () => import("/app/pages/recommended.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "something-went-wrong",
    path: "/something-went-wrong",
    component: () => import("/app/pages/something-went-wrong.vue")
  },
  {
    name: "staged",
    path: "/staged",
    meta: staged4ZpHHAhzcXMeta || {},
    component: () => import("/app/pages/staged.vue")
  }
]